module.exports = __webpack_public_path__ + "images/161d18b8451b12c3d0b396a6fd811571-bedroom-style1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/bedroom-style1.jpg
// module id = ./src/assets/images/content/bedroom-style1.jpg
// module chunks = 0